var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Season: "+_vm._s(_vm.$store.getters.currentSeason)+" "+_vm._s(_vm.getFullTeam(_vm.$store.getters.currentTeams)))])])}
var staticRenderFns = []

export { render, staticRenderFns }